import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { TaxReturnStatus } from "../../../app/tax-returns/tax-return/model/status";
import { ConfigStateService } from "../../../app/config/config-state.service";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrls: ['./status-badge.component.scss'],
    standalone: false
})
export class StatusBadgeComponent implements OnInit, OnDestroy {
  @Input() status: TaxReturnStatus;
  @Input() complexity?: number;

  subscriptions: Subscription[] = [];

  constructor(public config: ConfigStateService) { }

  ngOnInit() {
    this.subscriptions.push(this.config.loadConfig().subscribe(() => {}));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
